import { render } from "./LoadingIndicator.vue?vue&type=template&id=6182b9f2&scoped=true"
const script = {}

import "./LoadingIndicator.vue?vue&type=style&index=0&id=6182b9f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6182b9f2"]])

export default __exports__